import './Login.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { React, useState, useEffect } from 'react';

import Swal from 'sweetalert2';
import { Curriculum } from '../Curriculum/Curriculum';

const baseUrl = process.env.REACT_APP_API_URL;
const port = process.env.REACT_APP_API_PORT;

let nombreCliente = '';
let emailCliente = '';

const Login = () => {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [exist, setExist] = useState(false);
  const [tieneCv, setTieneCv] = useState(false);
  // const [idCurriculum, setIdCurriculum] = useState(null);
  const [idUsuario, setIdUsuario] = useState(null);

  const onChange = (e, setStatus) => {
    setStatus(e.target.value);
  };

  const buscarCliente = async () => {
    if (user.trim().length > 0 && pass.trim().length > 0) {
      const url = `${baseUrl}${port}/curriculumVitae/`;
      const resp = await fetch(url, {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify({
          user: `${user}`,
          pass: `${pass}`,
        }),
      });
      const data = await resp.json();

      if (data === 'Usuario Inexistente') {
        setExist(false);
        Swal.fire({
          title: 'Usuario Inexistente.',

          icon: 'warning',
          confirmButtonText: 'Ok',
          confirmButtonColor: '#F5B041',
        });
      } else {
        if (data === 'Clave Incorrecta') {
          Swal.fire({
            title: 'Clave Incorrecta.',

            icon: 'warning',
            confirmButtonText: 'Ok',
            confirmButtonColor: '#F5B041',
          });
        } else {
          setExist(true);
          setIdUsuario(data[0]);

          if (data[1].length === 0) {
            setTieneCv(false);
          } else {
            setTieneCv(true);
          }
        }
      }
    } else {
      Swal.fire({
        title: 'Debe completar todos los datos requeridos.',
        icon: 'warning',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#F5B041',
      });
    }

    // setCombo(data);
  };

  return (
    <>
      <>
        {!exist ? (
          <>
            <div className="title-login-container">
              <h1>Inicie sesión con su usuario y contraseña para continuar.</h1>
              <FontAwesomeIcon className="user-icon-login" icon={faUser} />
            </div>
            <div className="login-container">
              <div class="form-floating mb-3">
                <input
                  value={user}
                  onChange={e => onChange(e, setUser)}
                  type="text"
                  class="form-control"
                  id="floatingInput"
                  placeholder="name@example.com"
                />
                <label for="floatingInput">Usuario</label>
              </div>
              <div class="form-floating">
                <input
                  value={pass}
                  onChange={e => onChange(e, setPass)}
                  type="password"
                  class="form-control"
                  id="floatingPassword"
                  placeholder="Password"
                />
                <label for="floatingPassword">Contraseña</label>
              </div>

              <div className="btn-login-container">
                {' '}
                <button
                  onClick={buscarCliente}
                  type="button"
                  class="btn btn-primary"
                >
                  Ingresar
                </button>
              </div>
            </div>
          </>
        ) : (
          <>
            <Curriculum
              // idCurriculum={idCurriculum}
              idUsuario={idUsuario}
              setExist={setExist}
              exist={exist}
              tieneCv={tieneCv}
              setTieneCv={setTieneCv}
            />
          </>
        )}
      </>

      <></>
    </>
  );
};

export { Login };
